import { resilientFetch } from "@grandvisionhq/utils";
const fetch = resilientFetch();
const userAgentHeader = "GV-eCom-FE";
async function brHttpClient(options) {
  const { url, data, headers: originalHeaders, ...rest } = options;
  const headers = { ...originalHeaders, "User-Agent": userAgentHeader };
  const response = await fetch(url, { ...rest, headers, body: data });
  const contentType = response?.headers.get("content-type");
  if (!contentType?.includes("application/json")) {
    throw new Error(
      `Expected Bloomreach response type to be 'application/json' but got '${contentType}' instead`
    );
  }
  const json = await response.json();
  return { data: json };
}
export {
  brHttpClient,
  userAgentHeader
};
//# sourceMappingURL=http-client.js.map
